import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { BooleanToggle } from '../controls/boolean-toggle';
import type { SectionProps } from './types';

export const TagsSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <BooleanToggle
      label={t['com.streamlain.customApps.viewConfig.tags.label']()}
      description={t['com.streamlain.customApps.viewConfig.tags.desc']()}
      data-sl-field="tags"
      value={row.tags}
      onChange={v => setField('tags', v)}
    />
  );
};
